(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('.ns-display-product:not([data-ns-ready])').forEach(root => {
      root.dataset.nsReady = 'true';
      root.querySelectorAll('.ns-comparison input').forEach(input => {
        input.addEventListener('input', () => input.closest('.ns-comparison').style.setProperty('--ns-comparison', input.value + '%'));
      });
      root.querySelectorAll('[data-ns-healing-controls]').forEach(controls => {
        controls.addEventListener('click', event => {
          const button = event.target.closest('button[data-ns-healing-view]');
          if (!button) return;
          const card = controls.closest('.nsig-card--healing');
          card.dataset.nsHealingView = button.dataset.nsHealingView;
          controls.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        });
      });
      const gallery = root.querySelector('[data-product-photos]');
      if (gallery) {
        let frame;
        const updateHeight = () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => {
            const width = gallery.getBoundingClientRect().width;
            const height = Math.ceil(width * (window.matchMedia('(max-width: 768px)').matches ? 1 : 0.75));
            if (height > 0) gallery.style.setProperty('--ns-gallery-height', height + 'px');
          });
        };
        const selectionObserver = new MutationObserver(updateHeight);
        selectionObserver.observe(gallery, {subtree: true, attributes: true, attributeFilter: ['class'], childList: true});
        const sizeObserver = new ResizeObserver(updateHeight);
        gallery.querySelectorAll('.product-main-slide').forEach(slide => sizeObserver.observe(slide));
        updateHeight();
      }
      const zoomRoot = root.querySelector('[data-ns-gallery-zoom]');
      if (zoomRoot) {
        let dialog;
        let current = 0;
        let images = [];
        let trigger;
        const displayImage = () => {
          const source = images[current];
          const image = dialog.querySelector('img');
          image.src = source.dataset.photoswipeSrc || source.currentSrc || source.src;
          image.alt = source.alt;
          dialog.querySelector('[data-ns-zoom-count]').textContent = (current + 1) + ' / ' + images.length;
          dialog.querySelector('.ns-zoom-stage').scrollTo(0, 0);
          dialog.classList.remove('ns-zoom-expanded');
        };
        zoomRoot.addEventListener('click', event => {
          const clicked = event.target.closest('.js-photoswipe__zoom, .photoswipe__image');
          if (!clicked) return;
          const slide = clicked.closest('.product-main-slide');
          const source = slide && slide.querySelector('.photoswipe__image');
          if (!source) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          images = [...zoomRoot.querySelectorAll('.product-main-slide:not(.ns-info-slide) .photoswipe__image')];
          current = images.indexOf(source);
          trigger = clicked;
          if (!dialog) {
            dialog = document.createElement('dialog');
            dialog.className = 'ns-gallery-zoom';
            dialog.setAttribute('aria-label', zoomRoot.dataset.nsZoomLabel);
            dialog.innerHTML = '<div class="ns-zoom-toolbar"><span data-ns-zoom-count aria-live="polite"></span><button type="button" data-ns-zoom-close>×</button></div><div class="ns-zoom-stage"><img alt=""></div><button type="button" class="ns-zoom-prev">‹</button><button type="button" class="ns-zoom-next">›</button>';
            dialog.querySelector('[data-ns-zoom-close]').setAttribute('aria-label', zoomRoot.dataset.nsZoomClose);
            dialog.querySelector('.ns-zoom-prev').setAttribute('aria-label', zoomRoot.dataset.nsZoomPrev);
            dialog.querySelector('.ns-zoom-next').setAttribute('aria-label', zoomRoot.dataset.nsZoomNext);
            dialog.querySelector('[data-ns-zoom-close]').addEventListener('click', () => dialog.close());
            const move = direction => { current = (current + direction + images.length) % images.length; displayImage(); };
            dialog.querySelector('.ns-zoom-prev').addEventListener('click', () => move(-1));
            dialog.querySelector('.ns-zoom-next').addEventListener('click', () => move(1));
            dialog.querySelector('img').addEventListener('click', () => dialog.classList.toggle('ns-zoom-expanded'));
            dialog.addEventListener('keydown', event => {
              if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); }
            });
            dialog.addEventListener('close', () => { document.documentElement.classList.remove('ns-zoom-open'); if (trigger) trigger.focus({preventScroll: true}); });
            document.body.append(dialog);
          }
          displayImage();
          dialog.showModal();
          document.documentElement.classList.add('ns-zoom-open');
        }, true);
      }
      const subtitle = root.querySelector('[data-ns-subtitle]');
      const reviewWidget = root.querySelector('.ns-review-top');
      if (reviewWidget) {
        const source = reviewWidget.querySelector('[data-number-of-reviews]');
        const link = reviewWidget.querySelector('a');
        const scope = reviewWidget.querySelector('.ns-review-scope');
        if (source && link && scope) {
          const count = Number(source.dataset.numberOfReviews);
          const countLabel = document.createElement('span');
          countLabel.className = 'ns-review-count';
          countLabel.textContent = new Intl.NumberFormat(document.documentElement.lang || 'de').format(count) + ' ' + scope.textContent;
          link.append(countLabel);
          link.href = '#ns-customer-reviews';
        }
      }

      root.addEventListener('click', event => {
        const reviewLink = event.target.closest('.ns-review-top');
        if (!reviewLink) return;
        const reviews = document.querySelector('.jdgm-carousel-wrapper');
        if (!reviews) return;
        event.preventDefault();
        event.stopPropagation();
        reviews.id = 'ns-customer-reviews';
        reviews.setAttribute('tabindex', '-1');
        reviews.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
        reviews.focus({preventScroll: true});
      }, true);
      root.addEventListener('change', event => {
        if (!event.target.matches('[data-variant-input]') || !subtitle) return;
        const values = [...root.querySelectorAll('[data-variant-input]:checked')].map(input => input.value.toLowerCase());
        subtitle.textContent = values.some(value => value.includes('transpar')) ? subtitle.dataset.clearCopy : subtitle.dataset.mattCopy;
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('click', async event => {
    const button = event.target.closest('.ns-display-product .js-ns-bundle');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const root = button.closest('.ns-display-product');
    let error = root.querySelector('[data-ns-bundle-error]');
    if (!error) {
      error = document.createElement('p');
      error.dataset.nsBundleError = 'true';
      error.setAttribute('role', 'alert');
      button.after(error);
    }
    error.textContent = '';
    if (button.dataset.mattAvailable !== 'true' || button.dataset.transAvailable !== 'true') {
      error.textContent = root.dataset.bundleUnavailable;
      return;
    }
    const label = button.textContent;
    button.disabled = true;
    button.textContent = root.dataset.bundleLoading;
    const base = root.dataset.cartRoot.replace(/\/?$/, '/');
    try {
      const response = await fetch(base + 'cart/add.js', {
        method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: [{id: Number(button.dataset.mattId), quantity: 1}, {id: Number(button.dataset.transId), quantity: 1}]})
      });
      if (!response.ok) throw new Error('Cart rejected bundle');
      window.location.href = base + 'discount/BUNDLE20?redirect=' + encodeURIComponent(base + 'cart');
    } catch (failure) {
      error.textContent = root.dataset.bundleError;
      button.disabled = false;
      button.textContent = label;
    }
  }, true);
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-ns-gel-form]');
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.pending === 'true') return;
    const button = form.querySelector('button[type="submit"]');
    const status = form.closest('.ns-gel-upsell').querySelector('[data-ns-gel-status]');
    const label = button.textContent;
    form.dataset.pending = 'true';
    button.disabled = true;
    button.textContent = form.dataset.loading;
    status.textContent = '';
    try {
      const response = await fetch(form.action.replace(/\/?$/, '.js'), {
        method: 'POST', headers: {'Accept': 'application/json'}, body: new FormData(form)
      });
      if (!response.ok) throw new Error('Cart rejected accessory');
      await response.json();
      status.textContent = form.dataset.success;
      document.dispatchEvent(new CustomEvent('cart:build'));
    } catch (error) {
      status.textContent = form.dataset.error;
    } finally {
      form.dataset.pending = 'false';
      button.disabled = false;
      button.textContent = label;
    }
  }, true);
})();
